import { render, staticRenderFns } from "./PinnedDevicesPanel.vue?vue&type=template&id=28086622&scoped=true"
import script from "./PinnedDevicesPanel.vue?vue&type=script&lang=ts"
export * from "./PinnedDevicesPanel.vue?vue&type=script&lang=ts"
import style0 from "./PinnedDevicesPanel.vue?vue&type=style&index=0&id=28086622&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28086622",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28086622')) {
      api.createRecord('28086622', component.options)
    } else {
      api.reload('28086622', component.options)
    }
    module.hot.accept("./PinnedDevicesPanel.vue?vue&type=template&id=28086622&scoped=true", function () {
      api.rerender('28086622', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ota/PinnedDevicesPanel.vue"
export default component.exports